import * as OrganizationDetailsState from './org-details-state';

export { OrganizationDetailsStoreModule } from './org-details-store.module';
export { OrganizationDetailsState };
